"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iWeatherCondition = void 0;
const t = require("io-ts");
exports.iWeatherCondition = t.keyof({
    sunny: null,
    clear: null,
    partlycloudy: null,
    cloudy: null,
    drizzle: null,
    rainy: null,
    sleet: null,
    snowing: null
});
//# sourceMappingURL=weatherConditions.js.map